export * from './IconStarOliveBranchesGradient';
export { default as IconStarOliveBranchesGradient } from './IconStarOliveBranchesGradient';
